<form class="form-group mb-0 kt-padding-15 filter-by-status" [formGroup]="formGroup" (ngSubmit)="addFilter()">
  <div class="content-text-14-grey-1 mb-2">
    Filter by status
  </div>
  <ng-select #fieldSelect [virtualScroll]="true" formControlName="newField" [clearable]="false" [closeOnSelect]="false"
    (change)="softClose(fieldSelect)">
    <ng-option *ngFor="let option of getDisplayFilters(filterOptions)" [value]="option.field"
      [disabled]="isSelected(option.field)">{{ option.title }}</ng-option>
  </ng-select>
  <div class="text-start add-new-filter">
    <button class="btn mr-2 btn-add-filter" type="submit" [disabled]="!formGroup.value.newField">
      <i class="fa fa-plus"></i>{{ 'FILTERS.BUTTONS.ADD_TO_FILTERS' | translate }}</button>
  </div>
</form>
<div>
  <div class="form-group mb-0 kt-padding-15 filter-by-status">
    <div *ngIf="applied.observers.length">
      <button class="btn btn-secondary w-100 kt-margin-b-15 kt-padding-b-5 kt-padding-t-5"
        (click)="saveFilters(saveModal)" *ngIf="selectedFilters.length">Save new filter set</button>
    </div>
    <div *ngFor="let option of getDisplayFilters(selectedFilters)">
      <ng-container *ngIf="option.inputType === 'input'">
        <div class="d-flex align-items-center justify-content-between kt-margin-t-10">
          <label>{{ option.title }}</label><i (click)="removeFilter($event, option)" class="fa fa-times"
            aria-hidden="true"></i>
        </div>
        <div class="d-flex">
          <div class="btn-group" role="group" aria-label="Basic example"
            *ngIf="['Equal', 'LessThan', 'GreaterThan'].includes(option.type)">
            <button type="button" class="btn" [ngClass]="option.type === 'LessThan' ? 'btn-primary' : 'btn-secondary'"
              (click)="setType($event, option, 'LessThan')"><span class="fa fa-angle-left"
                aria-hidden="true"></span></button>
            <button type="button" class="btn"
              [ngClass]="option.type === 'GreaterThan' ? 'btn-primary' : 'btn-secondary'"
              (click)="setType($event, option, 'GreaterThan')"><span class="fa fa-angle-right"
                aria-hidden="true"></span></button>
            <button type="button" class="btn" [ngClass]="option.type === 'Equal' ? 'btn-primary' : 'btn-secondary'"
              (click)="setType($event, option, 'Equal')"><span class="fa fa-equals" aria-hidden="true"></span></button>
            <input type="number" class="form-control" [(ngModel)]="option.value">
          </div>
          <input type="text" class="form-control" [(ngModel)]="option.value"
            *ngIf="['StringEqual', 'StartsWith', 'Contains'].includes(option.type)">
        </div>
      </ng-container>
      <ng-container *ngIf="option.inputType === 'date'">
        <div class="d-flex align-items-center justify-content-between kt-margin-t-10">
          <label>{{ option.title }}</label><i (click)="removeFilter($event, option)" class="fa fa-times"
            aria-hidden="true"></i>
        </div>
        <div class="d-flex">
          <div class="btn-group" role="group" aria-label="Basic example"
            *ngIf="['Equal', 'LessThan', 'GreaterThan'].includes(option.type)">
            <button type="button" class="btn" [ngClass]="option.type === 'LessThan' ? 'btn-primary' : 'btn-secondary'"
              (click)="setType($event, option, 'LessThan')"><span class="fa fa-angle-left"
                aria-hidden="true"></span></button>
            <button type="button" class="btn"
              [ngClass]="option.type === 'GreaterThan' ? 'btn-primary' : 'btn-secondary'"
              (click)="setType($event, option, 'GreaterThan')"><span class="fa fa-angle-right"
                aria-hidden="true"></span></button>
            <button type="button" class="btn" [ngClass]="option.type === 'Equal' ? 'btn-primary' : 'btn-secondary'"
              (click)="setType($event, option, 'Equal')"><span class="fa fa-equals" aria-hidden="true"></span></button>
          </div>
        </div>
        <kt-date-picker [(ngModel)]="option.value"></kt-date-picker>
      </ng-container>
      <ng-container *ngIf="option.inputType === 'boolean'">
        <div class="d-flex align-items-center justify-content-between"><label>{{ option.title }}</label>
          <i (click)="removeFilter($event, option)" class="fa fa-times" aria-hidden="true"></i>
        </div>
        <div class="input-group">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [name]="option.field" value="true" [(ngModel)]="option.value"
              [checked]="option.value === 'true' ? true : false">
            <label class="form-check-label" for="inlineRadio1">Yes</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" [name]="option.field" value="false" [(ngModel)]="option.value"
              [checked]="option.value === 'false' ? true : false">
            <label class="form-check-label" for="inlineRadio2">No</label>
          </div>
        </div>
      </ng-container>
      <ng-container
        *ngIf="option.inputType !== 'input' && option.inputType !== 'boolean' && option.inputType !== 'date'">
        <div class="d-flex align-items-center justify-content-between">
          <label>{{ option.title }}</label>
          <i (click)="removeFilter($event, option)" class="fa fa-times" aria-hidden="true"></i>
        </div>
        <div class="input-group">
          <select class="form-control" [(ngModel)]="option.value" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let op of dropdownOptions(option.inputType)" [ngValue]="op">{{ op }}</option>
          </select>
        </div>
      </ng-container>
    </div>
    <div class="kt-margin-t-20" *ngIf="getAllFilters().length">
      <div class="content-text-14-grey-1 kt-margin-b-15">Saved filter sets</div>
      <button class="btn btn-label-brand w-100 kt-margin-b-15 kt-padding-t-5 kt-padding-b-5"
        *ngFor="let filter of getAllFilters()" (click)="applyFilters(filter)">{{filter}}</button>
    </div>
    <div class="mt-2" *ngIf="applied.observers.length">
      <button class="btn btn-brand" type="button" (click)="applyFilters()">{{ 'GENERAL.BUTTONS.APPLY' | translate
        }}</button>
      <button class="btn blue-txt-14 bg-white" (click)="closed.emit()" type="button">{{ 'GENERAL.BUTTONS.CANCEL' |
        translate }}</button>
    </div>
  </div>
</div>
<ng-template #saveModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ 'FILTERS.TITLE.SAVE_FILTER' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group kt-margin-t-20">
      <label>{{ 'FILTERS.FIELDS.NAME' | translate }}</label>
      <input #filterName class="form-control">
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      {{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-brand" (click)="save(filterName.value)">
      {{ 'GENERAL.BUTTONS.SAVE' | translate }}</button>
  </div>
</ng-template>